var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoArrowRigth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.601,
    height: 29.21,
    viewBox: "0 0 17.601 29.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7111",
    "data-name": "Group 7111",
    transform: "translate(0 29.21) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5312",
    "data-name": "Path 5312",
    d: "M14.605,17.6a2.986,2.986,0,0,1-2.118-.877L.877,5.114A3,3,0,0,1,5.114.877l9.491,9.491L24.1.877a3,3,0,0,1,4.237,4.237L16.723,16.723A2.986,2.986,0,0,1,14.605,17.6Z",
    transform: "translate(0 0)",
    fill: "#ced6de"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowRigth);
export default __webpack_public_path__ + "static/media/ICO-ARROW-RIGTH.caf6d2150afcd10eb27d1b91678909ac.svg";
export { ForwardRef as ReactComponent };